import type { ReactNode } from 'react';

import { cn } from '@/shared/lib/utils';

export interface SectionHeaderProps {
  /** Popisek sekce (uppercase). */
  children: ReactNode;
  /** Volitelná akce vpravo (např. tlačítko). */
  action?: ReactNode;
  className?: string;
}

/**
 * Sekční předěl ve formuláři / panelu — tučný popisek (tečka + uppercase) + předělová linka přes
 * zbytek šířky, volitelná akce vpravo.
 */
export function SectionHeader({ children, action, className }: SectionHeaderProps) {
  return (
    <div className={cn('gap-phx-3 flex items-center', className)}>
      <span className="text-phx-xs text-phx-text gap-phx-2 flex shrink-0 items-center font-bold tracking-wider uppercase">
        <span className="bg-phx-text inline-block h-1 w-1 rounded-full" />
        {children}
      </span>
      <span className="border-phx-border h-px flex-1 border-t" />
      {action ? <span className="shrink-0">{action}</span> : null}
    </div>
  );
}
